import { render } from "./TeamPage.vue?vue&type=template&id=bf555c88&scoped=true"
import script from "./TeamPage.vue?vue&type=script&lang=js"
export * from "./TeamPage.vue?vue&type=script&lang=js"

import "./TeamPage.vue?vue&type=style&index=0&id=bf555c88&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf555c88"]])

export default __exports__